import {getApi} from "../../data/ApiService";

const state = {
    loading: false,
    error: {},
    materialHomeBanner: {},
    materialHomeCatalogue: {},
    materialHomeFeatures: {},
    materialNews: {},
    materialProjects: {},
    materialProducts: {},
    materialNewsSlider:[],
    companyIntro: {},
    exports: {},
    management: {},
    buildStructure: {},
    representation: {},
    agencies: {},
    agenciesForm: {},
    materialArticles: {},
    materialCertificates: {},
    materialEvents: {},
    materialGallery: {},
    materialBanners:null,
}

const actions = {
    async getMaterialBanners({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/279/page/1/count/1000');
            commit('setMaterialBanners', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getMaterialNewsSlider({commit}){
        commit('setLoading', true);
        try {
            const response = await getApi('category/280/page/1/count/100');
            state.materialNewsSlider=response.data;
        }
        catch (e) {
            commit('setError',e.response.message);
        }
        finally {
            commit('setLoading', false);
        }
    },
    async getMaterialHomeBanner({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/139/page/1/count/100');
            commit('setMaterialHomeBanner', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getMaterialHomeCatalogue({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/61/page/1/count/100');
            commit('setMaterialHomeCatalogue', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getMaterialHomeFeatures({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('topics/28/page/1/count/100');
            commit('setMaterialHomeFeatures', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getMaterialNews({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/58/page/1/count/100');
            commit('setMaterialNews', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getMaterialEvents({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/59/page/1/count/100');
            commit('setMaterialEvents', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getMaterialGallery({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/60/page/1/count/100');
            commit('setMaterialGallery', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getMaterialArticles({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/62/page/1/count/100');
            commit('setMaterialArticles', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getMaterialCertificates({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/284/page/1/count/100');
            commit('setMaterialCertificates', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getMaterialProjects({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/281/page/1/count/1000');
            commit('setMaterialProjects', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getMaterialProducts({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/24/page/1/count/100');
            commit('setMaterialProducts', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getCompanyIntro({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/55/page/1/count/100');
            commit('setCompanyIntro', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getManagement({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/56/page/1/count/100');
            commit('setManagement', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
    async getMaterialExport({commit}) {
        commit('setLoading', true);
        try {
            const response = await getApi('category/57/page/1/count/100');
            commit('setMaterialExport', response);
        } catch (e) {
            commit('setError', e.response.message);
        } finally {
            commit('setLoading', false);
        }
    },
}

const mutations = {
    setMaterialBanners(state, resource) {
        state.materialBanners = resource.data.topics;
    },
    setMaterialHomeBanner(state, resource) {
        state.materialHomeBanner = resource.data.topics;
    },
    setMaterialHomeCatalogue(state, resource) {
        state.materialHomeCatalogue = resource.data;
    },
    setMaterialHomeFeatures(state, resource) {
        state.materialHomeFeatures = resource.data.topics;
    },
    setMaterialNews(state, resource) {
        state.materialNews = resource.data;
    },
    setMaterialEvents(state, resource) {
        state.materialEvents = resource.data;
    },
    setMaterialGallery(state, resource) {
        state.materialGallery = resource.data;
    },
    setMaterialProjects(state, resource) {
        state.materialProjects = resource.data;
    },
    setMaterialProducts(state, resource) {
        state.materialProducts = resource.data.topics;
    },
    setCompanyIntro(state, resource) {
        state.companyIntro = resource.data;
    },
    setManagement(state, resource) {
        state.management = resource.data;
    },
    setMaterialExport(state, resource) {
        state.exports = resource.data;
    },
    setRepresentation(state, resource) {
        state.representation = resource.data;
    },
    setAgenciesDetails(state, resource) {
        state.agencies = resource.data;
    },
    setAgenciesForm(state, resource) {
        state.agenciesForm = resource.data.data;
    },
    setMaterialArticles(state, resource) {
        state.materialArticles = resource.data;
    },
    setMaterialCertificates(state, resource) {
        state.materialCertificates = resource.data;
    },


    setLoading(state, loading) {
        state.loading = loading;
    },
    setError(state, error) {
        state.error = error;
    }
}

const getters = {}

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters,
}